import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, Command } from '../../../core/model/command';
import { Observable } from 'rxjs';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { leaseAgreementCommand } from '../../command/lease-agreement.command';
import { LeaseAgreementDocumentFormComponent } from '../../component/lease-agreement-document-form/lease-agreement-document-form.component';
import { ProfileService } from '../../../common/service/data/profile.service';

@Injectable()
export class LinkLeaseAgreementDocumentCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === leaseAgreementCommand.linkDocument && command.context;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean | void> {
    if (command instanceof Command) {
      return this._actionService.open(LeaseAgreementDocumentFormComponent, this._injector, null, command.context, false); // Do not use wide action window for document form
    }
  }
}
